import React from 'react'
import Slider from "react-slick";
import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useScrollbarWidth } from 'react-use'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const blacklist = [
  'dotInside',
  'ratio',
  'scrollbarWidth',
]

const StyledBox = styled(Box, {
  shouldForwardProp: prop => !blacklist.includes(prop),
})`
.slick-slider {
  ${({ scrollbarWidth }) => `
  --slick-slide-width: calc(min(var(--chakra-sizes-container-xs), calc(100vw - ${scrollbarWidth}px)) - var(--chakra-space-4) * 2);
  `};
}
.slick-dots {
  ${({ dotInside, ratio }) => dotInside && `
    bottom: auto;
    top: calc(var(--slick-slide-width) * 1 / ${ratio});
  `};

  li {
    button:before {
      color: ${({ theme }) => theme.colors?.custom?.text};
    }
  }
}
.slick-prev, .slick-next {
  top: calc(var(--slick-slide-width) * 0.5 / ${({ ratio }) => (ratio)});
  transform: translateY(-50%);
}
.slick-prev {
  left: 20px;
  z-index: 1;

  &:before {
    color: ${({ theme }) => theme.colors?.custom?.text};
    opacity: 0.5;
  }
}
.slick-next {
  right: 20px;
  &:before {
    color: ${({ theme }) => theme.colors?.custom?.text};
    opacity: 0.5;
  }
}
`

const Carousel = ({
  children,
  dotInside,
  ratio,
  ...props
}) => {
  const scrollbarWidth = useScrollbarWidth()
  return (
    <StyledBox
      dotInside={dotInside}
      ratio={ratio}
      pb={!dotInside && 6}
      scrollbarWidth={scrollbarWidth}
    >
      <Slider
        dots
        infinite
        arrows
        slidesToShow={1}
        slidesToScroll={1}
        {...props}
      >
        {children}
      </Slider>
    </StyledBox>
  )
}

export default Carousel
